module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Provincia"
    },
    model: {
      value: (_vm.user.provincia),
      callback: function($$v) {
        _vm.$set(_vm.user, "provincia", $$v)
      },
      expression: "user.provincia"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Partido"
    },
    model: {
      value: (_vm.user.partido),
      callback: function($$v) {
        _vm.$set(_vm.user, "partido", $$v)
      },
      expression: "user.partido"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Barrio"
    },
    model: {
      value: (_vm.user.barrio),
      callback: function($$v) {
        _vm.$set(_vm.user, "barrio", $$v)
      },
      expression: "user.barrio"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Calle"
    },
    model: {
      value: (_vm.user.calle),
      callback: function($$v) {
        _vm.$set(_vm.user, "calle", $$v)
      },
      expression: "user.calle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "number",
      "label": "Altura"
    },
    model: {
      value: (_vm.user.altura),
      callback: function($$v) {
        _vm.$set(_vm.user, "altura", $$v)
      },
      expression: "user.altura"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Piso"
    },
    model: {
      value: (_vm.user.piso),
      callback: function($$v) {
        _vm.$set(_vm.user, "piso", $$v)
      },
      expression: "user.piso"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Puerta"
    },
    model: {
      value: (_vm.user.puerta),
      callback: function($$v) {
        _vm.$set(_vm.user, "puerta", $$v)
      },
      expression: "user.puerta"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "number",
      "label": "C.P."
    },
    model: {
      value: (_vm.user.cp),
      callback: function($$v) {
        _vm.$set(_vm.user, "cp", $$v)
      },
      expression: "user.cp"
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-99d36fa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/UserProps.vue
// module id = 257
// module chunks = 3